export default {"src":"/_next/static/media/safepoints_64.d9e4b41f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};